import { InputField, Button } from "iq-blueberry"
import useCTA from "./hook"

import * as S from "./styles.js"

const CTA = ({ placeholder, errorMessage, textButton }) => {
  const { handleOnChange, handleOnClick, handleOnBlur, cpf, isInvalid } =
    useCTA()
  return (
    <div css={S.cta}>
      <div css={S.input}>
        <InputField
          value={cpf}
          onChange={handleOnChange}
          onBlur={handleOnBlur}
          useNumericKeyboard
          placeholder={placeholder}
          invalid={isInvalid}
          errorMessage={errorMessage || "CPF inválido"}
          maxLength={14}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              handleOnClick()
            }
          }}
        />
      </div>
      <div css={S.button}>
        <Button
          type="primary"
          justify="center"
          expand="x"
          onClick={handleOnClick}
        >
          {textButton || "Consulte grátis"}
        </Button>
      </div>
    </div>
  )
}

export default CTA
